import { VtsLog, type User } from "@/models"
import { Temporal } from "@/Temporal"

export function createBlankTemplateVtsLog(loggedInUser: User): VtsLog {
	return {
		id: 0,
		logTime: Temporal.Now.instant(),
		createdBy: loggedInUser.createTimeStamp(),
		editedBy: loggedInUser.createTimeStamp(),

		fromId: null!,
		fromOther: "",

		toId: null!,
		toOther: "",

		remarks: "",
	}
}
